import React from 'react';
import styled, { keyframes } from 'styled-components';

const pulseGlow = keyframes`
  0%, 100% { opacity: 0.35; transform: scale(1); }
  50% { opacity: 0.6; transform: scale(1.05); }
`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const Wrap = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
`;

const Base = styled.div`
  position: absolute;
  inset: 0;
  background: var(--bg-hero);
`;

const Mesh = styled.div`
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 80% 60% at 75% 20%, rgba(109, 187, 26, 0.1) 0%, transparent 55%),
    radial-gradient(ellipse 50% 40% at 15% 85%, rgba(14, 107, 60, 0.07) 0%, transparent 50%),
    radial-gradient(ellipse 30% 30% at 90% 70%, rgba(242, 183, 5, 0.05) 0%, transparent 50%);
`;

const Grid = styled.div`
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(14, 107, 60, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(14, 107, 60, 0.03) 1px, transparent 1px);
  background-size: 56px 56px;
  mask-image: radial-gradient(ellipse 100% 80% at 50% 30%, black 15%, transparent 75%);
`;

const Orb = styled.div`
  position: absolute;
  border-radius: 50%;
  filter: blur(70px);
  animation: ${pulseGlow} 14s ease-in-out infinite;

  &.a {
    width: 420px;
    height: 420px;
    top: -15%;
    right: 5%;
    background: rgba(109, 187, 26, 0.16);
  }

  &.b {
    width: 320px;
    height: 320px;
    bottom: -10%;
    left: -5%;
    background: rgba(14, 107, 60, 0.1);
    animation-delay: -6s;
  }
`;

const Ring = styled.div`
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(14, 107, 60, 0.06);

  &.r1 {
    width: 380px;
    height: 380px;
    top: 5%;
    right: 8%;
    animation: ${spin} 90s linear infinite;
  }

  &.r2 {
    width: 260px;
    height: 260px;
    top: 12%;
    right: 16%;
    border-color: rgba(109, 187, 26, 0.07);
    animation: ${spin} 70s linear infinite reverse;
  }
`;

const PageBackdrop = ({ variant = 'hero' }) => (
  <Wrap aria-hidden="true">
    <Base />
    <Mesh />
    {variant === 'hero' && <Grid />}
    <Orb className="a" />
    <Orb className="b" />
    {variant === 'hero' && (
      <>
        <Ring className="r1" />
        <Ring className="r2" />
      </>
    )}
  </Wrap>
);

export default PageBackdrop;
